export default {
  SET: (state, payload) => {
    if(Array.isArray(payload)) {
      payload.map(obj => {
        state[obj.key] = obj.value;
      })
    } else {
      state[payload.key] = payload.value;
    }
  },
};